import { atom } from "recoil";

export const UserState = atom({
  key: "user",
  default: {},
});
